import { Validators } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';
import { HOST_ACC_STATUS_SELECT_CONFIG, HOST_ACC_RENEWAL_TYPE_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const hostAccFormConfig = (): FormConfig => {
  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã', required: true, width: '1/2',
        type: 'text', placeholder: 'Nhập mã tài khoản host',
        disabled: (editMode: boolean) => editMode,
        tooltip: (editMode: boolean, formValue: any) => editMode && formValue.code ? 'Không thể sửa mã nhân viên đã có' : '',
      },
      {
        key: 'name', label: 'Tên', required: true, width: '1/2',
        type: 'text', placeholder: 'Nhập tên tài khoản host',
      },
      {
        key: 'email', label: 'Email', width: 'full',
        type: 'text', validators: [Validators.email], placeholder: 'Nhập địa chỉ email',
        customErrorMessage: 'Email không hợp lệ'
      },
      {
        key: 'status',
        label: 'Trạng thái',
        type: 'select',
        required: true,
        width: '1/3',
        config: { ...HOST_ACC_STATUS_SELECT_CONFIG },
        customErrorMessage: 'Vui lòng chọn trạng thái'
      },
      {
        key: 'renewalType',
        label: 'Loại gia hạn',
        type: 'select',
        required: true,
        width: '1/3',
        config: { ...HOST_ACC_RENEWAL_TYPE_SELECT_CONFIG },
        customErrorMessage: 'Vui lòng chọn loại gia hạn'
      },
      {
        key: 'renewDate',
        label: 'Ngày gia hạn',
        type: 'datepicker',
        required: false,
        width: '1/3',
        placeholder: 'Chọn ngày gia hạn'
      },
      {
        key: 'note',
        label: 'Ghi chú',
        type: 'textarea',
        required: false,
        width: 'full',
        placeholder: 'Nhập ghi chú'
      }
    ]
  };
};

